import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#send_svg__clip0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.96 4.784l-5.116 15.349c-.886-1.772-1.685-3.235-2.398-4.38.076-.132.169-.287.276-.464.354-.585.84-1.356 1.332-2.129a330.18 330.18 0 011.81-2.805l.172-.261-.837-.548-.548-.837-.261.171a342.194 342.194 0 01-2.805 1.81c-.772.493-1.543.979-2.128 1.333-.177.107-.333.2-.465.276-1.144-.712-2.607-1.512-4.38-2.399L19.96 4.784zM8.62 12.502h.002-.001zM15.2 9.546l-.548-.837a1 1 0 011.385 1.385l-.837-.548zm-3.339 3.339a90.7 90.7 0 00-.849 1.368c-.182.3-.34.568-.45.77-.053.098-.107.201-.148.293-.018.042-.05.115-.073.2a1.017 1.017 0 00.124.849c.758 1.16 1.662 2.79 2.713 4.907a1.84 1.84 0 003.439-.13l5.339-16.016a1.839 1.839 0 00-2.336-2.336L3.602 8.129a1.84 1.84 0 00-.129 3.439c2.118 1.051 3.749 1.955 4.907 2.712a1.018 1.018 0 00.847.125c.085-.024.158-.054.2-.073a4.09 4.09 0 00.294-.148c.203-.11.47-.268.771-.45.397-.24.87-.535 1.368-.85zm.382 3.24a.022.022 0 000-.001v.001z",
      fill: "#2d6ded"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "send_svg__clip0" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
), t = a;
export {
  t as default
};
